// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import moment from 'moment'
import createCSV from 'helpers/createCSV'
import create2dArrayOfResults from './create2dArrayOfResults'

const parseAndExportResultsData = (state, { label }, scrubber) => {
  const {
    columns,
    results,
    tableSort,
  } = state

  // do nothing if there are no results currently
  if (!results.length) {
    return false
  }

  // since the export button doesn't have access to the results data,
  // if the db set needs it's data scrubbed have the export button pass the
  // parsing function to exportResults.
  const scrubbedData = (
    scrubber
      ? scrubber(results)
      : results
  )

  const data = create2dArrayOfResults(columns, scrubbedData, tableSort)
  const dataTableLabel = label.replace(' ', '_')
  const dateStamp = moment(Date.now()).format('YYYYMMDD')
  const title = `${dataTableLabel}_Search_${dateStamp}`
  createCSV(title, data)
}

export default parseAndExportResultsData
